import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "n-icon" }
const _hoisted_2 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-skip-previous-icon',
},
  __name: 'skip-previous-icon',
  props: {
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      fill: __props.fill,
      viewBox: "0 0 24 24"
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M6,18V6H8V18H6M9.5,12L18,6V18L9.5,12Z"
      }, null, -1)
    ]), 8, _hoisted_2))
  ]))
}
}

})